import React from 'react';
import { Navigate } from 'react-router-dom';
import authService from '../../services/authService';

const LoginCallback = () => {
  const [done, setDone] = React.useState(false);

  React.useEffect(() => {
    authService.handleLoginCallback(window.location.href).then(() => {
      setDone(true);
    });
  }, []);

  if (!done) {
    return null;
  }
  return <Navigate to="/" />;
};

export default LoginCallback;
